import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

interface FilterInfoLabelProps {
  label: string;
  tooltip: string;
}

const FilterInfoLabel: React.FC<FilterInfoLabelProps> = ({ label, tooltip }) => {
  return (
    <div className="relative inline-flex items-center gap-1.5 group">
      <span>{label}</span>
      <button
        type="button"
        aria-label={`${label} information`}
        className="inline-flex items-center justify-center rounded-full text-gray-400 transition hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
      >
        <InformationCircleIcon className="h-4 w-4" />
      </button>
      <div className="pointer-events-none absolute left-0 top-full z-30 hidden w-72 rounded-xl border border-slate-200 bg-white p-3 text-xs font-normal normal-case tracking-normal text-slate-600 shadow-xl group-hover:block group-focus-within:block">
        {tooltip}
      </div>
    </div>
  );
};

export default FilterInfoLabel;
